module.exports = __webpack_public_path__ + "img/865ef23.jpg";